import React, { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import axios from "axios";
import { toast } from "react-toastify";
import { BASE_URL, IMAGE_URL, security_key } from "../../../global";
import VideoPlayer from "./VideoPlayer";
import author from "../../../Assets/img/authors/author.webp";
import Pagination from "@mui/material/Pagination";
import Stack from "@mui/material/Stack";
import ArticleLoader from "../../Common/ArticleLoader";

const CategoryPage = () => {
    const { id } = useParams();
    const [articles, setArticles] = useState([]);
    const [activePipVideo, setActivePipVideo] = useState(null);
    const [currentlyPlaying, setCurrentlyPlaying] = useState(null);
    const [pageSize, setPageSize] = useState(8);
    const [page, setPage] = useState(1);
    const [totalCount, setTotalCount] = useState(0);
    const [currentCategory, setCurrentCategory] = useState(null);
    const [categories, setCategories] = useState([]);
    const [isLoading, setIsLoading] = useState(false);

    const [issmallSize, setIsSmallSize] = useState(window.innerWidth < 576);
    useEffect(() => {
        // Function to update screen size
        const handleResize = () => {
            setIsSmallSize(window.innerWidth < 576);
        };

        // Add event listener for window resize
        window.addEventListener("resize", handleResize);

        // Clean up the event listener on component unmount
        return () => window.removeEventListener("resize", handleResize);
    }, []);

    useEffect(() => {
        setPage(1);
        setPageSize(8);
        const getAllNavCategory = async () => {
            try {
                const response = await axios.post(BASE_URL + "API/apicall", {
                    security_key: security_key,
                    mode: "getAllNavCategory",
                });

                const output = response.data;
                setCategories(output);

                // Set the current category based on the ID from URL params
                const category = output.find((cat) => cat.pk_cat_key === id);
                if (category) {
                    setCurrentCategory(category);
                    fetchArticles(category.pk_cat_key); // Fetch articles for the selected category
                }
            } catch (error) {
                toast.error("Error fetching categories.", { autoClose: 3000 });
            }
        };

        getAllNavCategory();
    }, [id]); // Only run when the ID changes

    const fetchArticles = async (categoryId) => {
        setIsLoading(true);
        try {
            const response = await axios.post(BASE_URL + "API/apicall", {
                security_key: security_key,
                pk_cat_key: categoryId,
                mode: "getArticlesByCategory2",
                offset: (page - 1) * pageSize,
                limit: pageSize,
            });

            if (response.data && Array.isArray(response.data.data)) {
                setArticles(response.data.data);
                setTotalCount(response.data.totalCount);
            } else {
                toast.error("Invalid response format.", { autoClose: 3000 });
            }
        } catch (error) {
            toast.error("Error fetching articles.", { autoClose: 3000 });
        } finally {
            setIsLoading(false);
        }
    };

    // const handleChange = (event, value) => {
    //     setPage(value);
    //     if (currentCategory) {
    //         fetchArticles(currentCategory.pk_cat_key);
    //     }
    // };
    const handleChange = (event, value) => {
        setPage(value);
    };

    useEffect(() => {
        if (currentCategory) {
            fetchArticles(currentCategory.pk_cat_key);
        }
    }, [page, currentCategory]);

    const totalPages = Math.ceil(totalCount / pageSize);

    return (
        <div>
            <main className="mt-15">
                <div className="container">
                    <section className="latest-post mb-30">
                        <h3 className="widget-header widget-header-style-1 font-weight-bold text-center mb-20">
                            {currentCategory && <span className="pl-15 pr-15 font-family-normal"># {currentCategory.cat_name}</span>}
                        </h3>
                        <div className="loop-grid row vertical-divider">
                            {isLoading ? (
                                Array.from({ length: 4 }).map((_, index) => (
                                    <article className="col-lg-3 col-md-6 col-sm-12" key={index} style={{ maxWidth: "100%" }}>
                                        <ArticleLoader width={300} />
                                    </article>
                                ))
                            ) : articles && articles.length > 0 ? (
                                articles.slice(0, 4).map((row, index) => (
                                    <article key={index} className="col-lg-3 col-md-6 col-sm-12">
                                        <Link to={`/detail/${row.pk_ac_key}`} state={{ catKey: id }}>
                                            <div className="entry-meta meta-0 font-small">
                                                {row.tag_master &&
                                                    JSON.parse(row.tag_master).map((item) => (
                                                        <a key={item.pk_tag_key}>
                                                            <span className="post-cat position-relative"># {item.tag}</span>
                                                        </a>
                                                    ))}
                                            </div>
                                            <h5 className="post-title font-weight-bold mb-8">{row.ac_name.slice(0, 40) + (row.ac_name.length > 40 ? '...' : '')}</h5>
                                            <p className="excerpt mb-12">{row.ac_summary.slice(0, 170)}</p>
                                            <figure className="mb-12 ">
                                                {row.additionalFields &&
                                                    JSON.parse(row.additionalFields).map((item, index) => {
                                                        if (index === 0) {
                                                            return item.base_type === "video" ? (
                                                                <div style={{ height: "200px" }}>
                                                                    <VideoPlayer
                                                                        key={index}
                                                                        src={IMAGE_URL + item.file_name}
                                                                        activePipVideo={activePipVideo}
                                                                        setActivePipVideo={setActivePipVideo}
                                                                        currentlyPlaying={currentlyPlaying}
                                                                        setCurrentlyPlaying={setCurrentlyPlaying}
                                                                        className="h-100"
                                                                    />
                                                                </div>
                                                            ) : (
                                                                <img
                                                                    key={index}
                                                                    className={issmallSize ? "img-fluid w-100" : "img-sm-fluid w-100"}
                                                                    src={IMAGE_URL + item.file_name}
                                                                    alt=""
                                                                    height={200}
                                                                    style={{ height: "200px" }}
                                                                />
                                                            );
                                                        }
                                                        return null;
                                                    })}
                                            </figure>
                                            <div className="entry-meta meta-2 text-uppercase font-x-small color-muted">
                                                {row.author_info &&
                                                    JSON.parse(row.author_info).map((item, index) => (
                                                        <span key={index}>
                                                            <a className="float-left mr-10 author-img">
                                                                <img src={IMAGE_URL + item.profile} alt="" />
                                                            </a>{" "}
                                                            By
                                                            <a>
                                                                <span className="author-name">{item.first_name + " " + item.last_name}</span>
                                                            </a>
                                                            <span className="create-date ml-30">{row.mod_publish_date}</span>
                                                        </span>
                                                    ))}
                                                <div className="horizontal-divider mt-16 mb-8"></div>
                                            </div>
                                        </Link>
                                    </article>
                                ))
                            ) : (
                                <div className="col-12 text-center py-0 my-0 d-flex justify-content-center align-items-center" style={{height:"350px"}}>
                                    <p className="f-24 mb-0">No articles available</p>
                                </div>
                            )}
                        </div>
                        <div className="loop-grid row vertical-divider">
                            {isLoading
                                ? Array.from({ length: 8 }).map((_, index) => (
                                      <article className="col-lg-3 col-md-6 col-sm-12 d-flex justify-content-center" key={index} style={{ maxWidth: "100%" }}>
                                          <ArticleLoader width={300} />
                                      </article>
                                  ))
                                : articles.slice(4, 8).map((row, index) => (
                                      <article key={index} className="col-lg-3 col-md-6 col-sm-12 d-flex justify-content-center">
                                          <Link to={`/detail/${row.pk_ac_key}`} state={{ catKey: id }}>
                                              <div className="entry-meta meta-0 font-small">
                                                  {row.tag_master &&
                                                      row.tag_master !== "undefined" &&
                                                      JSON.parse(row.tag_master).map((item) => (
                                                          <a key={item.pk_tag_key}>
                                                              <span className="post-cat position-relative"># {item.tag}</span>
                                                          </a>
                                                      ))}
                                              </div>
                                              <h5 className="post-title font-weight-bold mb-8 ">{row.ac_name.slice(0, 40) + (row.ac_name.length > 40 ? '...' : '')}</h5>
                                              <p className="excerpt mb-12">{row.ac_summary.slice(0, 180)}</p>
                                              <figure className="mb-12">
                                                  {row.additionalFields &&
                                                      row.additionalFields !== "undefined" &&
                                                      JSON.parse(row.additionalFields).map((item, index) => {
                                                          if (index === 0) {
                                                              return item.base_type === "video" ? (
                                                                  <div style={{ height: "200px" }}>
                                                                      <VideoPlayer
                                                                          key={index}
                                                                          src={IMAGE_URL + item.file_name}
                                                                          activePipVideo={activePipVideo}
                                                                          setActivePipVideo={setActivePipVideo}
                                                                          currentlyPlaying={currentlyPlaying}
                                                                          setCurrentlyPlaying={setCurrentlyPlaying}
                                                                          className="h-100"
                                                                      />
                                                                  </div>
                                                              ) : (
                                                                  <img
                                                                      className={issmallSize ? "img-fluid w-100" : "img-sm-fluid w-100"}
                                                                      key={index}
                                                                      src={IMAGE_URL + item.file_name}
                                                                      alt=""
                                                                      height={200}
                                                                      style={{ height: "200px" }}
                                                                  />
                                                              );
                                                          }
                                                          return null;
                                                      })}
                                              </figure>
                                              <div className="entry-meta meta-2 text-uppercase font-x-small color-muted">
                                                  {JSON.parse(row.author_info).map((item, index) => (
                                                      <>
                                                          <a className="float-left mr-10 author-img">
                                                              <img src={IMAGE_URL + item.profile} alt="" />
                                                          </a>{" "}
                                                          By
                                                          <a>
                                                              <span className="author-name">{item.first_name + " " + item.last_name}</span>
                                                          </a>
                                                          <span className="create-date ml-30">{row.mod_publish_date}</span>
                                                      </>
                                                  ))}
                                                  <div className="horizontal-divider mt-16 mb-8"></div>
                                              </div>
                                          </Link>
                                      </article>
                                  ))}
                        </div>
                    </section>
                    <Stack spacing={2} className="my-3 mx-0 px-0">
                        <Pagination count={totalPages} page={page} onChange={handleChange} />
                    </Stack>
                </div>
            </main>
        </div>
    );
};

export default CategoryPage;
